module.exports = __webpack_public_path__ + "static/img_1556-0d468cbe4474245857901acef5992320.webp";